<button
  appButton
  name="success-close"
  location="progress-upload-toasts-item"
  [iconButton]="true"
  spacing="1"
  color="simple-gray"
  height="1"
  shape="round"
  class="close-button"
  data-test-id="close-upload-success"
  (click)="close()"
>
  <app-svg src="/assets/icons/cross.svg"></app-svg>
</button>

<div class="success-icon">
  @if (failedUploads().length) {
    <app-svg src="/assets/icons/64/alert-triangle.svg" color="orange"></app-svg>
  } @else {
    <app-animated-svg src="/assets/animations/checkmark.svg"></app-animated-svg>
  }
</div>
<div class="success-info">
  @if (failedUploads().length) {
    <h3>Failed Upload</h3>
  } @else {
    <h3>Upload completed!</h3>
  }
  @if (failedUploads().length) {
    <h4>{{ failedUploads().length }} of {{ uploads().length }} assets failed to upload.</h4>
  } @else {
    <h4>
      {{ uploadedAssetCount() }}
      @if (uploadedAssetCount() !== 1) {
        assets,
      } @else {
        asset,
      }
      {{ uploadedTotalSize() | dataUnitsBigInt }}
    </h4>
  }
</div>
<div class="success-buttons">
  @if (failedUploads().length) {
    <button
      appButton
      name="error-details"
      location="progress-upload-toasts-item"
      weight="bold"
      shape="round"
      spacing="3"
      (click)="showFailedUploads()"
    >
      <span>Show Details</span>
    </button>
  } @else {
    <button
      appButton
      name="success-settings"
      location="progress-upload-toasts-item"
      [hasIcon]="true"
      spacing="full"
      shape="round"
      (click)="openGallerySettingsDialog()"
    >
      <app-svg src="/assets/icons/gear.svg"></app-svg>
      <span>Settings</span>
    </button>
    <button
      appButton
      name="success-share"
      location="progress-upload-toasts-item"
      color="primary"
      weight="bold"
      shape="round"
      [hasIcon]="true"
      spacing="full"
      (click)="openShareDialog()"
    >
      <app-svg src="/assets/icons/forward.svg"></app-svg>
      <span>Share</span>
    </button>
  }
</div>
